import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { ThemeProvider, createTheme } from '@mui/material';
import { ptBR } from '@mui/material/locale';
import { ptBR as corePtBR } from '@mui/x-data-grid/locales';
import './i18n'

const theme = createTheme(
  {
    palette: {
      primary: { main: '#1976d2' },
    },
    components: {
      MuiInputLabel: {
        styleOverrides: {
          root: {
            fontSize: '0.9rem',
            top: '3px'
          },
        },
      },
    }
  },
  ptBR,
  corePtBR
);

ReactDOM.render(
  <React.StrictMode>
    <ThemeProvider theme={theme}>
      <App />
    </ThemeProvider>
  </React.StrictMode>,
  document.getElementById('root')
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
